class DataService {

  constructor($http, $rootScope, $location) {
    "ngInject";
    this.$http = $http;

    this.synergistMission = 'Synergist develops mission critical software applications for the Federal Government. We are looking for the best and brightest engineering talent who possess exceptional technical skills and the ability to convey solutions to our customers in a manner in which they understand.  At Synergist, creativity and new ideas are not only welcomed, they’re expected.';
    this.synergistNoChange = 'Also, don’t worry about us changing any time soon.  We are owned and operated by software engineers and plan to stay that way.  Most importantly, our employees come first. A company is only as good as the people that work for it. Which is why we do everything in our power to keep you happy and focused -- enabling you to come to work and excel.';

    this.synergistNother = 'Don’t worry about being stuck in the same position forever as we provide all of our employees with opportunities to switch teams and projects as you and your skill set grows and your interests evolve.'

      //In today’s market software engineers need to be highly capable problem solvers that understand a wide variety of technologies and how to apply the best ones to solve the problem. We also expect you to be a thought leader, which means you need to stand up and get the job done no matter what it takes.

    this.desiredExpIntro = 'We realize that we are about to enumerate a bunch of skills and experience here.  Don’t worry if you don’t have all of these, but we’d like you to have touched some of these technologies or concepts or at least be familiar with them.'
  }

  getNews() {
    return this.$http.get('./api/news');
  }

  getJobs() {
    let service = this;
    return this.$http.get('./api/jobs');
  }

  getInternalJobs() {
    let service = this;
    return this.$http.get('./api/jobDescriptions');
  }

  getJob(jobId){
    return this.$http.get('./api/jobs/'+jobId);
  }
}



export default DataService;



// WEBPACK FOOTER //
// ./app/services/dataService/data.service.js